import permissionsConstants from './constants/permissionsConstants';
import PermissionsManager from './manager/permissionsManager';

export const permissions = {
    permissionsConstants: permissionsConstants,
    permissionsManager: PermissionsManager
};
